import { speechClient } from '@/speech/api'

// Optional adoption statistics. Never await this job in the chat send/result path.
// Each job owns immutable IDs and an account-bound client; no audio or text is sent.
export function createSpeechAdoptionReporter(clientFactory = speechClient) {
  const clients = new Set()
  let closed = false
  return {
    report(association) {
      if (closed || !association.recognitionIds.length) return Promise.resolve(false)
      const payload = { ...association, recognitionIds: association.recognitionIds.slice() }
      return (async () => {
        let client
        try {
          if (closed) return false
          client = clientFactory({ timeout: 5000 })
          clients.add(client)
          for (let attempt = 0; attempt < 2 && !closed; attempt++) {
            try { await client.post('submit', payload); return true }
            catch (error) { if (error.definitive) return false }
          }
          return false
        } catch (_) { return false }
        finally { if (client) { clients.delete(client); client.close() } }
      })()
    },
    close() {
      closed = true
      clients.forEach(client => client.close())
      clients.clear()
    }
  }
}
